<script setup>
import { onBeforeMount, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";

import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import ProfileCard from "./components/ProfileCard.vue";
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
// import ArgonButton from "@/components/ArgonButton.vue";

const body = document.getElementsByTagName("body")[0];

const store = useStore();

onMounted(() => {
  store.state.isAbsolute = true;
  setNavPills();
  setTooltip();
});
onBeforeMount(() => {
  store.state.imageLayout = "profile-overview";
  store.state.showSidenav = false;
  store.state.showNavbar = false;
  store.state.showFooter = true;
  store.state.hideConfigButton = true;
  body.classList.add("profile-overview");
  if (localStorage.getItem("token")) {
    store.state.showSidenav = true;
    status = true;
  }
});
onBeforeUnmount(() => {
  store.state.isAbsolute = false;
  store.state.imageLayout = "default";
  store.state.showNavbar = true;
  store.state.showFooter = true;
  store.state.hideConfigButton = false;
  body.classList.remove("profile-overview");
});
</script>
<template>
  <main>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0" v-text="Registro"></p>
              </div>
            </div>
            <div class="card-body">
              <p class="text-uppercase text-sm">
                Actualiza la Informacion de Usuario
              </p>

              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Usuario: {{ user.id }}</label
                  >
                </div>
                <div class="col-md-6"></div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Password</label
                  >
                  <argon-input type="password" v-model="user.password" />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Confirmar Password</label
                  >
                  <argon-input type="password" v-model="user.password" />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Nombre</label
                  >
                  <input
                    class="form-control"
                    type="text"
                    v-model="user.nombre"
                  />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Apellido Paterno</label
                  >
                  <argon-input type="text" v-model="user.paterno" />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Apellido Materno</label
                  >
                  <argon-input type="text" v-model="user.materno" />
                </div>
              </div>
              <hr class="horizontal dark" />
              <p class="text-uppercase text-sm">Information de Contacto</p>
              <div class="row">
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Telefono</label
                  >
                  <argon-input type="number" v-model="user.telefono" />
                </div>
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Email</label
                  >
                  <argon-input type="text" v-model="user.email" />
                </div>
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Status</label
                  >
                  <argon-switch
                    :value="user.status"
                    @change="user.status = $event.target.checked"
                  >
                    Activo
                  </argon-switch>
                </div>
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Tipo</label
                  >
                  <argon-switch
                    :value="user.tipo"
                    @change="user.tipo = $event.target.checked"
                  >
                    Administrador
                  </argon-switch>
                </div>
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Fecha de Creacion:
                  </label>
                  <label>{{ user.fechaCreacion }}</label>
                </div>
                <p v-if="this.model.errorMessage" style="color: red">
                  {{ this.model.errorMessage }}
                </p>
                <argon-button
                  class="mt-4"
                  variant="gradient"
                  color="info"
                  fullWidth
                  size="sm"
                  @click.prevent="saveData"
                  >Actualizar</argon-button
                >
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-md-4" v-show="status">
          <profile-card />
        </div> -->
      </div>
    </div>
  </main>
</template>
<script>
import usuario from "../api/usuario";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
// import ArgonRadio from "@/components/ArgonRadio.vue";
import Swal from "sweetalert2";
export default {
  components: {
    // ProfileCard,
    ArgonInput,
    ArgonSwitch,
    // ArgonRadio,
  },
  props: {
    user: {
      type: Object,
      required: true,
      id: {
        type: Number,
        required: true,
      },
      nombre: {
        type: String,
        required: true,
      },
      paterno: {
        type: String,
        required: true,
      },
      materno: {
        type: String,
        required: true,
      },
      usuario: {
        type: String,
        required: true,
      },
      telefono: {
        type: Number,
        required: true,
      },
      email: {
        type: String,
        required: true,
      },
      password: {
        type: String,
        required: true,
      },
      status: {
        type: Boolean,
        required: true,
      },
      tipo: {
        type: String,
        required: true,
      },
      nivel: {
        type: String,
        required: true,
      },
      fechaCreacion: {
        type: String,
        required: true,
      },
    },
  },
  data() {
    return {
      status: null,
      model: {
        id: "",
        type: "registro",
        usuario: "",
        password: "",
        confirmPassword: "",
        nombre: "",
        paterno: "",
        telefono: "",
        errorMessage: "",
        status: false,
        token: "",
      },
    };
  },
  created() {
    // this.model = user
  },
  methods: {
    validatePassword() {
      if (this.model.password.length > 0) {
        if (this.model.password !== this.model.confirmPassword) {
          this.model.errorMessage = "La contraseña no coincide";
          this.model.status = false;
        } else {
          this.model.status = true;
        }
      } else {
        this.model.errorMessage =
          "La contraseña debe de tener un tamaño mayor a 0";
        this.model.status = false;
      }
    },
    async saveData() {
      this.model= this.user
      this.model.token = localStorage.getItem("token")
      this.model.confirmPassword = this.user.password
      this.model.errorMessage = null;
      this.validatePassword();
      if (
        this.model.status &&
        this.model.nombre.length > 0 &&
        this.model.paterno.length > 0 &&
        this.model.telefono.length > 0
      ) {
        usuario
          .update(this.model)
          .then((result) => {
            if (result.data.message != null) {
              Swal.fire({
                title: "Actualizacion Correcta",
                text: result.data.message,
                icon: "success",
                confirmButtonColor: "success",
                confirmButtonText: "Continuar",
              });
              this.$router.push({ path: "/usuarios" });
            } else {
              Swal.fire({
                title: "Error de Registro",
                text: result.data.error,
                icon: "error",
                confirmButtonColor: "error",
                confirmButtonText: "Continuar",
              });
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        return;
      }
    },
    async updateData() {
      this.model.token = localStorage.getItem("token");
      usuario
        .update(this.model)
        .then((result) => {
          if (result.data.message != null) {
            Swal.fire({
              title: "Actualizacion Correcta",
              text: result.data.message,
              icon: "success",
              confirmButtonColor: "success",
              confirmButtonText: "Continuar",
            });
            this.model = null
            this.$router.push({ path: "/usuarios" });
          } else {
            Swal.fire({
              title: "Error al actualizar",
              text: result.data.error,
              icon: "error",
              confirmButtonColor: "error",
              confirmButtonText: "Continuar",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
